const helps = [
  'понять задачу;',
  'освоить новый навык;',
  'самостоятельно принимать решения;',
  'анализировать ошибки;',
  'получать обратную связь;',
  'постепенно брать больше ответственности.',
];

export default function WhatIsMentoring() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Наставничество — это не просто передача опыта
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Между «я покажу сотруднику, как сделать» и «я помогу сотруднику научиться делать это самостоятельно» есть принципиальная разница. Хороший наставник не просто передаёт собственные способы работы — он помогает сотруднику:
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto mb-12">
          {helps.map((h, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{h}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed font-semibold text-center">
            Цель наставничества — не сделать сотрудника зависимым от наставника, а повысить его самостоятельность.
          </p>
        </div>
      </div>
    </section>
  );
}